import { useEffect, useState } from "react";
import { ICategory, IMenu, IPotluck } from "interfaces";
import { useService, useSession } from "contexts";

export const useSummary = (initPotluck: IPotluck) => {
  const { potluckService } = useService();
  const { isAuthenticated, user } = useSession();

  const [shareOpened, setShareOpened] = useState<boolean>(false);
  const [manageItemOpened, setManageItemOpened] = useState<boolean>(false);
  const [viewMenuOpened, setViewMenuOpened] = useState<boolean>(false);
  const [viewResponseOpened, setViewResponseOpened] = useState<boolean>(false);

  const [menuIndex, setMenuIndex] = useState<number>(0);
  const [categoryId, setCategoryId] = useState<string>("");
  const [currentPotluck, setCurrentPotluck] = useState<IPotluck>(initPotluck);

  useEffect(() => {
    potluckService.update(currentPotluck);
  }, [currentPotluck, potluckService]);

  const isActive = new Date(currentPotluck.date) > new Date();
  const isOwner = isAuthenticated ? user.id === currentPotluck.created_by._id : false;

  const currentCategory = currentPotluck.menu[menuIndex].categories.find((category: ICategory) => category._id === categoryId);

  const getCurrentCategories = currentPotluck.menu[menuIndex].categories.find(
    (category: ICategory) => category._id === categoryId
  );

  const getFilteredResponse = (category: ICategory, vote: boolean) => category.responses.filter((c) => c.vote === vote);

  const getNotCancelledCategories = (menu: IMenu) => menu.categories
    .filter((category: ICategory) => !category.cancelled);

  const getSortedCategories = (menu: IMenu) => getNotCancelledCategories(menu).sort(
    (a: ICategory, b: ICategory) =>
      getFilteredResponse(b, true).length -
      getFilteredResponse(a, true).length
  );

  const handleUpdateCategory = (id: string, category: ICategory) => {
    setCurrentPotluck((prev) => {
      const newMenu = [...prev.menu];
      const index = newMenu[menuIndex].categories.findIndex(c => c._id === id);
      newMenu[menuIndex].categories[index] = category;
      return { ...prev, menu: newMenu };
    });
  };

  const handleCancelCategory = (id: string) => {
    setCurrentPotluck((prev) => {
      const newMenu = [...prev.menu];
      const index = newMenu[menuIndex].categories.findIndex(c => c._id === id);
      newMenu[menuIndex].categories[index].cancelled = true;
      return { ...prev, menu: newMenu };
    });
    setManageItemOpened(false);
  };

  return {
    canEdit: isActive && isOwner,
    menuIndex,
    currentCategory,
    currentPotluck,
    getCurrentCategories,
    getFilteredResponse,
    getSortedCategories,
    handleUpdateCategory,
    handleCancelCategory,
    manageItemOpened,
    setCategoryId,
    setMenuIndex,
    setManageItemOpened,
    setShareOpened,
    shareOpened,
    viewMenuOpened,
    viewResponseOpened,
    setViewMenuOpened,
    setViewResponseOpened,
  };
};
